module.exports = __webpack_public_path__ + "media/npc_dota_hero_lina.e8bdcf75.webm";